import css from './index.module.scss';
import {
    EFXBoostLogoH5,
    EFAirFryer,
    EFCoffeeMaker,
    EFElectircDrills,
    EFMicrowaveOven,
    EFElectricHeater,
    EFElectircFryPan,
    EFHairDryer,
    EFElectricKettle,
} from '@/components/UI/svg/xboost';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function ABanner() {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('xboost');
    const xboostIcons = [
        {
            id: 1,
            icon: <EFAirFryer style={{ fontSize: '48px' }} />,
            title: t('sec2_icon1_title'),
            num: t('sec2_icon1_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 2,
            icon: <EFCoffeeMaker style={{ fontSize: '48px' }} />,
            title: t('sec2_icon2_title'),
            num: t('sec2_icon2_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 3,
            icon: <EFElectircDrills style={{ fontSize: '48px' }} />,
            title: t('sec2_icon3_title'),
            num: t('sec2_icon3_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 4,
            icon: <EFMicrowaveOven style={{ fontSize: '48px' }} />,
            title: t('sec2_icon4_title'),
            num: t('sec2_icon4_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 5,
            icon: <EFElectricHeater style={{ fontSize: '48px' }} />,
            title: t('sec2_icon5_title'),
            num: t('sec2_icon5_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 6,
            icon: <EFElectircFryPan style={{ fontSize: '48px' }} />,
            title: t('sec2_icon6_title'),
            num: t('sec2_icon6_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 7,
            icon: <EFHairDryer style={{ fontSize: '48px' }} />,
            title: t('sec2_icon7_title'),
            num: t('sec2_icon7_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 8,
            icon: <EFElectricKettle style={{ fontSize: '48px' }} />,
            title: t('sec2_icon8_title'),
            num: t('sec2_icon8_num'),
            unit: t('sec2_icon_unit'),
        },
    ];

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    // 动画改为css触发式
    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;
        new ScrollMagic.Scene({
            triggerElement: '.A_banner',
            triggerHook: 1,
            offset: layoutH * 1 + 10,
        })
            .setClassToggle('.A_banner', 'enter')
            .addTo(controller);
    }, []);

    return (
        <div className={`A_banner ${css.A_banner}`}>
            <div className="allBox">
                <div className="videoBox">
                    <div className="innerVideoBox">
                        <div className="video-box-opacity">
                            <EFVideo
                                sources={['/video/xboost/h5/01_KV.webm', '/video/xboost/h5/01_KV.mp4']}
                                className="banner_video"
                                width={'100%'}
                                height="100%"
                                muted
                                autoPlay
                                playsInline
                                loop
                                preload="auto"
                            />
                        </div>
                        <div className="logoBox">
                            <EFXBoostLogoH5 width="2.91rem" height=".8rem" />
                        </div>
                    </div>
                    <div className="textBox">
                        <div className="innerBox">
                            <p className="title">{t('section_2_title')}</p>
                            <p className="desc">{t('section_2_desc')}</p>
                            <div className="iconBox">
                                {xboostIcons?.map((icon: any) => (
                                    <div className="iconItem" key={icon?.id}>
                                        {icon?.icon}
                                        <p className="name">{icon?.title}</p>
                                        <div className="power">
                                            <span className="num">{icon?.num}</span>
                                            <span className="unit">{icon?.unit}</span>
                                        </div>
                                    </div>
                                ))}
                                <p className="memo">{t('sec2_memo')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
